export default __webpack_public_path__ + "c633412284901c3dc157029aab685b3b.png";